<template>
  <div class="aboutUs">
    <div>
      <img src="./aboutus1.png" alt="" class="width100">
    </div>
    <div class="aboutBox">
      <div class="container">
        <p class="tit">
          北京云标科技有限公司（云标物联）
        </p>
        <div class="word">
          <p>北京云标科技有限公司(云标物联)是一家IT综合服务公司，具有丰富的应用软件实施与开发经验，为教育、医疗、餐饮、商业、旅游、广告传媒等行业提供智能化咨询服务与解决方案。</p>
          <p>云医馆-中药堂智慧服务系统，是公司旗下一套以“中医+互联网”为核心，为便民就医为初衷，同时完善提升中医机构管理水平而研发的一套集自助机预约挂号、移动便捷支付、药房管理、医生管理、会员管理、电子药方、数据统计分析等功能为一体的全流程闭环管理系统。
          </p>
          <p>该系统将自助服务系统、信息发布系统、触摸查询系统、导览查询系统、排队叫号系统等诸多系统与传统中医管理进行有效融合，将物联网、数据对接、云平台管理、4G网络、移动支付、大数据统计分析等工具植入中医管理体系中，旨在让祖国的传统中医实现信息化管理，从简化预约挂号流程、优化医生排班管理、方便患者选择医生和门诊部、方便管理者依托数据统计分析进行管理上的经营决策，提升传统中药堂的运营效率，降低运营管理成本，同时降低医疗风险。
          </p>
          <p>云标物联有一支优秀的技术研发团队，完善的管理体系。本着“合作，沟通，信任，奉献，互补”的团队精神，以创新的软件应用，稳定的硬件系统，优良的售后服务保障，为祖国的传统中医诊所管理提供最优质的服务。
          </p>
          <p> <span class="bold">经营策略：</span>专于技术、精于服务、强于品质、成于特色。</p>
          <p> <span class="bold">经营理念：</span>以市场为导向、以技术为基础、以创新求发展、以诚信为保证。</p>
        </div>
        <div class="row mes marginTop40">
          <div class="col-xs-12 col-sm-12 col-md-3 text-center">
            <img src="./aboutus3.png" alt="">
          </div>
          <div class="col-xs-12 col-sm-12 col-md-9 fontSize18">
            <p class="
             bold">全国统一服务热线：<a href="tel:400-168-1191" class="color333">400-168-1191</a></p>
            <div class="flex flex-start">
              <span class="bold">销售服务：</span>
              <div class="fontSize18">
                <p>董经理：<a href="tel:13611292757" class="color333">13611292757</a></p>
                <p>左经理：<a href="tel:18500058818" class="color333">18500058818</a></p>
              </div>
            </div>

            <dl class="flex align-items fontSize18">
              <dt class="bold">地址：</dt>
              <dd class="fontSize18">北京海淀上地七街联创大厦407</dd>
            </dl>
            <div class="flex flex-start fontSize18">
              <div>
                <p><span class="bold">地铁：</span>13号线/昌平线(西二旗下车)</p>
                <p><span class="bold">公交：</span>软件园东站、软件园南站、上地七街环岛</p>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  export default {};
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .aboutUs
    .tit
      font-size 48px
      margin-bottom 130px
  .aboutBox
    padding-top 97px
    width:100%
    background: url(./aboutus2.png) top center no-repeat
    background-size: cover
    .word
      font-size 18px;
      p
        text-indent 2em
        line-height 1.5
        margin-bottom 20px
    .mes2
      font-size 18px
      .bold
        font-size: 24px
        white-space nowrap
        margin-right 10px
@media (min-width: 320px) and (max-width: 750px)
  .aboutUs
    .aboutBox
      padding-top: 36px;
    .tit
      font-size 28px
      margin-bottom 30px
</style>



// WEBPACK FOOTER //
// src/components/aboutus/aboutus.vue